import React from 'react';
import Helpers from 'utils/helpers';
import './divider.css'

export default function Divider(props) {
  const getClass = () => {
    let classNames = ['divider'];
    if (props.size) {
      classNames.push(`divider-${props.size}`);
    }
    else {
      classNames.push('divider-md');
    }
    if (props.position) {
      classNames.push(`divider-${props.position}`);
    }
    else {
      classNames.push('divider-center');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()}>
      <span className='divider-content'>
        {props.text || props.children}
      </span>
    </div>
  );
}